import api from '@/services/api';
import type { DealerOption, ProductOption, UserOption } from '../types/filters.types';

const securityPath = '/security';

interface Option {
    id: string;
    name: string;
}

export const fetchUserDealers = async (userId: string): Promise<DealerOption[]> => {
    try {
        const response = await api.get(`${securityPath}/users/${userId}/dealers`);

        return (
            response.data.dealers?.map((dealer: Option) => ({
                value: dealer.id,
                label: dealer.name,
            })) || []
        );
    } catch (error) {
        console.error('Failed to fetch user dealers:', error);
        throw error;
    }
};

export const fetchUserProducts = async (userId: string): Promise<ProductOption[]> => {
    try {
        const response = await api.get(`${securityPath}/users/${userId}/products`);

        return (
            response.data.products?.map((product: Option) => ({
                value: product.id,
                label: product.name,
            })) || []
        );
    } catch (error) {
        console.error('Failed to fetch user products:', error);
        throw error;
    }
};

export const fetchUserColleagues = async (userId: string): Promise<UserOption[]> => {
    try {
        const response = await api.get(`${securityPath}/users/${userId}/related-users`);

        return (
            response.data.related_users?.map((user: Option) => ({
                value: user.id,
                label: user.name,
            })) || []
        );
    } catch (error) {
        console.error('Failed to fetch user colleagues:', error);
        throw error;
    }
};
